import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'
import { end_points } from '../../../services/core.index'
import { ApiServiceContext } from '../../../utils/shared.module'
import DriverProfile from './driverProfile'
import Offcanvas from 'react-bootstrap/Offcanvas'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'

function DriversList() {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)
  const { getData } = useContext(ApiServiceContext)
  const [listData, setListData] = useState<any>([])
  const [totalPage, setTotal] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [limitCount] = useState<number>(100)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [profileData, setProfileData] = useState<any>(null)
  const [showProfile, setShowProfile] = useState<boolean>(false)

  const getDriversList = async (search?: any) => {
    let nameSearch = search
    if (nameSearch == undefined) {
      nameSearch = ''
    }
    const urls = end_points.getUsers.url
    // urls += `?page=${page}&limit=${limitCount}&searchTerm=${nameSearch}`

    const response = await getData(urls)
    if (response?.status == 200) {
      // console.log(response?.data?.data);
      setListData(response?.data?.data)
      // setTotal(response?.data?.total_records)

      setLoading(false)
    }
  }

  const handleClose = () => setShowProfile(false)

  const handleView = (e: React.MouseEvent<HTMLButtonElement>, data: any) => {
    e.preventDefault()
    setProfileData(data)
    setShowProfile(true)
  }

  useEffect(() => {
    getDriversList()
  }, [])

  useEffect(() => {
    dispatch(setAppTitle('Drivers List'))
  }, [])

  const data = listData.map((item: any) => {
    return {
      id: item?.id,
      driver_name: item?.user_Name,
      email: item?.email,
      company_name: item?.companyName,
      license_number: item?.license_Number,
      phone_number: item?.phone_Number,
      vin_number: item?.vin_number,
      model_name: item?.model,
      vehicle_year: item?.year,
      status: item?.user_Status ? 'active' : 'inactive',
    }
  })

  const driverName = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='driver-preview.html' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar1}
              alt='Profiles'
            />
          </a>
          <a href='driver-preview.html'>
            {data?.driver_name} <span>{data?.company_name}</span>
          </a>
        </h2>
      </>
    )
  }
  const licene = (data: any, index: any) => {
    return <>{data.license_number}</>
  }

  const contact = (data: any, index: any) => {
    return (
      <>
        <span className='light-text'>{data.phone_number}</span>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <span className='badge bg-light-success'>{data.status}</span>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <div className='dropdown'>
          <a
            href='javascript:void(0);'
            className='dropdown-toggle'
            data-bs-toggle='dropdown'
          >
            <i className='feather-more-vertical'></i>
          </a>
          <div className='dropdown-menu dropdown-menu-end'>
            {/* <Link to={routes.driverProfile.path} onClick={()=>{
						dispatch(setProfileData(data))
					}} className="dropdown-item">
						<i className="feather-eye"></i> View								
					</Link> */}
            {/* <Link to='#' onClick={() => handleView({ data })} className="dropdown-item">
						<i className="feather-eye"></i> View								
					</Link> */}
            <a className='dropdown-item' onClick={(e) => handleView(e, data)}>
              <i className='feather-eye'></i> View
            </a>

            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-edit'></i> Edit
            </a>
            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-trash-2'></i> Delete
            </a>
          </div>
        </div>
      </>
    )
  }

  const vehicleInfo = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar2}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            {data.model_name} <span>{data.vin_number}</span>
          </a>
        </h2>
      </>
    )
  }

  return (
    <>
      <Offcanvas show={showProfile} onHide={handleClose} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <DriverProfile profileData={profileData} />

          {/* Content of your offcanvas goes here */}
          <p>This is the content of the Offcanvas.</p>
        </Offcanvas.Body>
      </Offcanvas>

      <div className='content container-fluid'>
        <div className='page-header'>
          <div className='row align-items-center'>
            <div className='col-sm-6'>
              <h3 className='page-title'>Drivers List</h3>
            </div>
            <div className='col-sm-6'>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item active'>
                  <a href='index.html'>Home</a>
                </li>
                <li className='breadcrumb-item'>Drivers List</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='row align-items-center'>
          <div className='col-md-6'>
            <div className='truck-list'>
              <ul className='nav'>
                <li className='active'>
                  <a href='javascript:void(0);'>All</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>Active</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>In Active</a>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='truck-search'>
              <div className='truck-search-input'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                />
              </div>
              <div className='truck-search-filter'>
                <a href='javascript:void(0);' className='btn btn-light'>
                  Filters <i className='ti ti-filter'></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card table-card'>
              <div className='card-body'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <div id='tablelength'></div>
                  </div>
                  <div className='col-md-6'>
                    <ul className='nav nav-table-filter'>
                      <li>Search:</li>
                      <li>
                        <div id='tablefilter'></div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='table-responsive'>
                  <table className='table datatable mb-0'>
                    <DataTable
                      // paginatorTemplate='CurrentPageReport  PrevPageLink PageLinks NextPageLink  '
                      // currentPageReportTemplate='{first} to {last} of {totalRecords} items'
                      className=''
                      value={data}
                      paginator
                      rows={5}
                      tableStyle={{ minWidth: '50rem' }}
                    >
                      <Column field='id' header='id' sortable></Column>

                      <Column
                        field='Driver Name'
                        header='Driver Name'
                        body={driverName}
                        sortable
                      ></Column>
                      <Column
                        field='Licene Number'
                        header='Licene Number'
                        body={licene}
                        sortable
                      ></Column>
                      <Column
                        field='Contact'
                        header='Contact'
                        body={contact}
                        sortable
                      ></Column>
                      <Column
                        field='Vehicle'
                        header='Vehicle Info'
                        body={vehicleInfo}
                        sortable
                      ></Column>

                      <Column
                        field='status'
                        header='Status'
                        body={status}
                        sortable
                      ></Column>
                      <Column body={action}></Column>
                    </DataTable>
                  </table>
                </div>
                <div className='tab-footer'>
                  <div className='row align-items-center'>
                    <div className='col-md-6'>
                      <div id='tableinfo'></div>
                    </div>
                    <div className='col-md-6'>
                      <div id='tablepage'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <DriverProfile profileData={profileData}></DriverProfile> */}
    </>
  )
}
export default DriversList
